module.exports = __webpack_public_path__ + "img/LoonityLogoWhite.8a3acf4a.svg";